import styled, { createGlobalStyle } from '@xstyled/styled-components';

// #region Styles
export const GlobalStyle = createGlobalStyle`
  body {
    font-family: Arial, sans-serif;
    font-size: 16px;
    line-height: 1.6;
    color: #333;
    margin: 0;
    padding: 0;
    background-color: #f7f7f7;
    overflow: hidden;
    /* Prevent body from scrolling */
  }
`;
export const AppDiv = styled.div`
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  margin: 0;
  padding: 0;
  background-color: #f7f7f7;
  overflow: hidden;
  /* Prevent body from scrolling */
`;
